<template>
  <div id="Add_employee" class="xv_modal">
    <div class="modal_title">
      <div>
        <span>New Employee</span>
      </div>
      <div>
        <button class="modal_close" @click="close_add_employee()">
          <span class="mdi mdi-close"></span>
        </button>
      </div>
    </div>
    <div class="modal_content">
      <div class="row">
        <div class="col-12">
          <label>Employee Id</label>
          <input type="text" placeholder />
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <label>Email Id</label>
          <input type="text" placeholder />
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <label>Mobile number</label>
          <input type="text" placeholder />
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <label>Office</label>
          <select name id>
            <option value="1">Microsoft</option>
            <option value="1">Apple</option>
            <option value="1">Nestle</option>
            <option value="1">Alphabet</option>
            <option value="1">Facebook</option>
            <option value="1">Alibaba</option>
            <option value="1">Tencent</option>
          </select>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <label>Role</label>
          <select name id>
            <option value="1">Super admin</option>
            <option value="1">Office admin</option>
            <option value="1">Bio security</option>
            <option value="1">Employee</option>
          </select>
        </div>
      </div>
      <div class="row">
        <div class="col-4">
          <label>Status</label>
          <select name id>
            <option value="1">Ok</option>
            <option value="1">Block</option>
            <option value="1">Work from home</option>
          </select>
        </div>
        <div class="col-4">
          <label>Till when</label>
          <input type="text" />
        </div>
        <div class="col-4">
          <label>Comments</label>
          <input type="text" />
        </div>
      </div>
    </div>
    <div class="modal_footer">
      <button class="sec_btn m_r" @click="close_add_employee()">Cancel</button>
      <button class="main_btn">Add</button>
    </div>
  </div>
</template>

<script>
// import employeePolicies from "./employee_policies/employee_policies.vue"

export default {
  name: "Add_employee",
  components: {
    // employeePolicies,visitorPolicies,healthDeclarations,securityPartners,company,account
  },
  data() {
    return {
      step_count: 1
    };
  },
  methods: {
    close_add_employee: function() {
      this.$modal.hide("add_employee");
    }
  }
};
</script>
